export default "__VITE_ASSET__Ctptp7Is__"